import React from 'react'
import { sortByInt } from '../../helpers'
import { Card, CardHeader } from '../../components/Card'
import Icon from '../../components/Icon'
import { InfoRow, InfoText } from './styled'

const CurrentParams = ({ current }) => {
    const sortData = sortByInt({ direct: 'asc', key: 'order' })
    return (
        <Card>
            <CardHeader>
                {current.title}
            </CardHeader>
            {
                current.data &&
                sortData(current.data).map(param => (
                    <InfoRow
                        key={param.title}
                    >
                        <Icon name={param.state === 0 ? "icon_tick" : "alert"} />
                        <InfoText>{`${param.title} ${param.value}`}</InfoText>
                    </InfoRow>
                ))
            }
        </Card>
    )
}

export default CurrentParams